import React from 'react'
import { IoClose } from 'react-icons/io5'

function Todos( {todos, setTodos, deleteItems} ) {
  return (
    <>
        <div className='bg-gray-700 mx-5 p-5 rounded-lg mt-10 sm:max-w-xl sm:mx-auto'>
        <ul>
            {todos.map(({id, title}) => (
                <ul className='flex items-center justify-between border-b border-gray-600'>
                    <li
                    key={id} 
                    className='todo-list text-white px-5 py-2 tracking-wider'
                    >{title}</li>
                    <button><IoClose className='text-red-400' onClick={() => deleteItems(id)}/></button>
                </ul>
            ))}

            <ul className='flex items-center justify-between px-5 py-3'>
                <li>
                    <p className='text-sm text-gray-400'>
                        {todos.length} items left
                    </p>
                </li>
                <li>
                    <button className='text-sm text-gray-400' onClick={() => setTodos([])}>Clear List</button>
                </li>
            </ul>

        </ul>
    </div>
    </>
  )
}

export default Todos;